import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { Container, Tab, Tabs, } from '@mui/material';
import { a11yProps, TabPanels } from 'components/mui/Tabs';
import useSwiperTabs from 'hooks/useSwiperTabs';
import useDidUpdateEffect from 'hooks/useDidUpdateEffect';
import { PartyType } from 'models/PartyModel';
import Table from 'modules/parties/common/Table';


const types = Object.values(PartyType);

const PartiesInner = () => {
    const {t} = useTranslation();
    const [query, setQuery] = useQueryParams({
        type: withDefault(StringParam, types[0]),
        id: NumberParam,
    });
    const {index, setIndex, setSwiper} = useSwiperTabs(types.indexOf(query.type as PartyType));

    const change = (idx: number, fromSwiper?: boolean) => {
        setIndex(idx, fromSwiper);
        setQuery({type: types[idx], id: undefined});
    };

    useDidUpdateEffect(() => setIndex(types.indexOf(query.type as PartyType)), [query.type]);

    const id = 'parties';

    return (
        <Container maxWidth={false} sx={{mt: 2}}>
            <Tabs
                variant="scrollable"
                value={index}
                onChange={(e, v) => change(v)}
                aria-label="Party type tabs"
            >
                {types.map(type => <Tab key={type} label={t(type)} {...a11yProps(id, type)}/>)}
            </Tabs>

            <TabPanels
                active={index}
                id={id}
                setIndex={change}
                setSwiper={setSwiper}
                narrow
                tabs={types.map(t => <Table key={t} type={t} id={query.id}/>)}
            />
        </Container>
    )
};

const Parties = () => {
    return (
        <Suspense fallback={null}>
            <PartiesInner/>
        </Suspense>
    )
}

export default Parties;
